import React                                from 'react';
import { Theme, makeStyles as _makeStyles, withTheme as _withTheme } from '@material-ui/core/styles';
import { withStyles as _withStyles }        from 'rewire-ui';

type _Style<T> = { [P in keyof T]: string; };
// use const ooga: StyleType<typeof cardStyle> = undefined;
export type StyleType<T extends (...args: any) => any> = _Style<ReturnType<T>>;

export function makeStyles<T extends (...args: any) => any, Props>(style: T) {
  return _makeStyles(style as any) as (props?: Props) => StyleType<T>;
}

export function withStyles<P>(styles: any, component: any) {
  return _withStyles(styles, component) as unknown as React.ComponentClass<P>;
}

export function withTheme<P>(component: any) {
  return _withTheme(component) as unknown as React.ComponentClass<P>;
}

export type { Theme };
